import * as React from "react";
import { Box } from "@mui/material";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuItem from "@mui/material/MenuItem";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { ListItemIcon, ListItemSecondaryAction, Menu } from "@mui/material";
import { IconBase } from "react-icons/lib";
import { useNavigate } from "react-router-dom";
import FallbackLogo from './FallbackLogo';

export default function Drawer({ headerTitle, value, onBackPress }) {
  const navigate = useNavigate();
  const [logoError, setLogoError] = React.useState(false);

  const [state, setState] = React.useState({
    left: false,
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 320 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <Box
        sx={{
          p: 1,
          display: "flex",
          alignItems: "center",
          gap: 1,
          bgcolor: "#667eea",
          mx: 1,
          mt: 3,
          borderRadius: "10px",
        }}
      >
        <img src="/images/drawer_gift.svg" alt="arrow" />

        <Typography fontWeight="500" color="white" fontSize={15}>
          Premium hasn’t been activated yet. Tap to upgrade.
        </Typography>
        <img src="/images/rightside_arrow.svg" alt="arrow" />
      </Box>

      <Divider />

      <List>
        <Typography variant="subtitle2" sx={{ p: 2, color: "gray" }}>
          SETTINGS
        </Typography>

        {[
          {
            text: "Language",
            icon: <img src="/images/drawer_language.svg" alt="Language" />,
          },
          {
            text: "Rate Us On Google Play",
            icon: <img src="/images/drawer_star.svg" alt="Settings" />,
          },
          {
            text: "Activate Push Notifications",
            icon: <img src="/images/drawer_notification.svg" alt="Settings" />,
          },
          {
            text: "Feedback",
            icon: <img src="/images/drawer_edit.svg" alt="Settings" />,
          },
          {
            text: "Contact Us",
            icon: <img src="/images/drawer_customercare.svg" alt="Settings" />,
          },
          {
            text: "Share With Friends",
            icon: <img src="/images/drawer_share.svg" alt="Settings" />,
          },
        ].map((item, index) => (
          <ListItem
            component="div"
            sx={{ border: "1px solid #E0E0E0", cursor: "pointer" }}
            key={index}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}

        {/* Logout Button */}
        <ListItem
          component="div"
          sx={{ 
            border: "1px solid #ff4444", 
            cursor: "pointer",
            backgroundColor: "#fff5f5",
            "&:hover": {
              backgroundColor: "#ffe0e0"
            }
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleLogout();
          }}
        >
          <ListItemIcon>
            <LogoutIcon sx={{ color: "#ff4444" }} />
          </ListItemIcon>
          <ListItemText 
            primary="Logout" 
            sx={{ 
              color: "#ff4444",
              fontWeight: "500"
            }} 
          />
        </ListItem>

        <Divider />

        <Typography variant="subtitle2" sx={{ p: 2, color: "gray" }}>
          ABOUT US
        </Typography>

        {[
          {
            text: "Term Of Service",
            icon: <img src="/images/drawer_notes.svg" alt="Settings" />,
          },
          {
            text: "Privacy Policy",
            icon: <img src="/images/drawer_contacts.svg" alt="Settings" />,
          },
        ].map((item, index) => (
          <ListItem
            component="div"
            sx={{ border: "1px solid #667eea", mx: 1, cursor: "pointer" }}
            key={index}
          >
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
            <ListItemSecondaryAction>
              <IconButton edge="end">
                <IconBase />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar 
        position="fixed" 
        sx={{ 
          backgroundColor: "#667eea !important",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important",
          boxShadow: "0 4px 20px rgba(102, 126, 234, 0.3) !important"
        }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={toggleDrawer("left", true)}
          >
            {value === 1 ? (
              <img src="images/back.svg" alt="share" onClick={onBackPress} />
            ) : (
              <MenuIcon />
            )}
          </IconButton>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1 }}>
            <Box
              sx={{
                width: 32,
                height: 32,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              {!logoError ? (
                <Box
                  component="img"
                  src="/images/logo-simple.svg"
                  alt="MySocialBizCard Logo"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    filter: 'brightness(0) invert(1)',
                  }}
                  onError={() => setLogoError(true)}
                />
              ) : (
                <FallbackLogo 
                  size={32} 
                  color="white" 
                  showText={false} 
                />
              )}
            </Box>
            <Typography variant="h6" component="div">
              {headerTitle}
            </Typography>
          </Box>
          <IconButton
            size="large"
            edge="end"
            color="inherit"
            aria-label="more"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenuOpen}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
            <MenuItem onClick={handleMenuClose}>Settings</MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <SwipeableDrawer
        anchor="left"
        open={state["left"]}
        onClose={toggleDrawer("left", false)}
        onOpen={toggleDrawer("left", true)}
        PaperProps={{
          sx: {
            borderTopRightRadius: "15px",
            borderBottomRightRadius: "15px",
          },
        }}
      >
        {list("left")}
      </SwipeableDrawer>
    </Box>
  );
}
